import { convertToUTCByMSK } from '../../../../../../utils'
import { ILedgerHistoryQuery } from './query.types'
import { ILedgerHistoryFilters } from './types'

// Даты фильтра — всегда МСК (не таймзона браузера, CPAYMENT-1642): в состоянии
// лежит Date со «стенными часами» МСК, обе границы переводятся в UTC только
// здесь, на границе с API. Смешение баз ломает выборку у сотрудников вне
// Москвы и невидимо при проверке из Москвы.
export const buildLedgerHistoryQuery = (
  filters: ILedgerHistoryFilters,
  pageSize: number,
  cursor?: string,
  allKindCodes: string[] = []
): ILedgerHistoryQuery => ({
  dateStart: filters.dateRange?.from ? convertToUTCByMSK(filters.dateRange.from) : undefined,
  dateEnd: filters.dateRange?.to ? convertToUTCByMSK(filters.dateRange.to) : undefined,
  walletId: filters.wallet || undefined,
  direction: filters.direction || undefined,
  kinds: selectedKinds(filters.kinds, allKindCodes),
  cursor,
  limit: pageSize,
})

// Полный выбор не передаётся: Ledger без параметра отдаёт все типы, включая
// появившиеся позже, которых нет в загруженном справочнике.
function selectedKinds(kinds: string[] | undefined, allKindCodes: string[]) {
  if (!kinds) return undefined
  if (allKindCodes.length > 0 && allKindCodes.every((code) => kinds.includes(code))) return undefined
  return kinds
}
